import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import {
  AuthMachineService,
  AuthService,
  RequestLogin,
  RequestLogout,
} from '@gyselroth/angular-auth';
import { OrganizationConfigService } from '../shared/organization/services/organizationConfig.service';

@Injectable({ providedIn: 'root' })
export class WebAuthService extends AuthService {
  private readonly router = inject(Router);
  private organizationConfigService = inject(OrganizationConfigService);

  constructor() {
    super(inject(AuthMachineService));
  }

  public init() {
    this.authenticated$.subscribe({
      next: ({ isAuthenticated, state }) => {
        if (isAuthenticated) {
          this.handleAuthenticated(
            state.context.redirectTo ??
              this.organizationConfigService.organization.loggedInRedirectToUrl
          );
        } else {
          this.handleAnonymous();
        }
      },
    });
  }

  public login() {
    this.send(new RequestLogin(null));
  }

  public async logoutUser() {
    this.send(new RequestLogout());
  }

  private async handleAuthenticated(redirectTo: string) {
    this.router.navigateByUrl(redirectTo, { replaceUrl: true });
  }

  private handleAnonymous() {
    this.router.navigateByUrl('/login', { replaceUrl: true });
  }
}
